/*
 * AdminDrawer Messages
 *
 * This contains all the text for the AdminDrawer component.
 */

import { defineMessages } from "react-intl";

export const scope = "app.components.AdminOrderActionsModal";

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: "Action Required",
  },
  subtitle: {
    id: `${scope}.subtitle`,
    defaultMessage:
      "Select the required action, type the accompanying text for the customer and send.",
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: "Cancel",
  },
  send: {
    id: `${scope}.send`,
    defaultMessage: "Send",
  },
  emptyMessage: {
    id: `${scope}.emptyMessage`,
    defaultMessage: "Fill in your message...",
  },
  patient: {
    id: `${scope}.patient`,
    defaultMessage: "Patient",
  },
  patient_nr: {
    id: `${scope}.patient_nr`,
    defaultMessage: "Int. patientnr.",
  },
  case_nr: {
    id: `${scope}.case_nr`,
    defaultMessage: "Case no.",
  },
  date: {
    id: `${scope}.date`,
    defaultMessage: "Date",
  },
  insurer: {
    id: `${scope}.insurer`,
    defaultMessage: "Insurer",
  },
  insurer_nr: {
    id: `${scope}.insurer_nr`,
    defaultMessage: "Insurer no.",
  },
  dentist: {
    id: `${scope}.dentist`,
    defaultMessage: "Dentist",
  },
  product_upper: {
    id: `${scope}.product_upper`,
    defaultMessage: "Product Upper jaw",
  },
  product_lower: {
    id: `${scope}.product_lower`,
    defaultMessage: "Product Lower jaw",
  },
  phase: {
    id: `${scope}.phase`,
    defaultMessage: "Treatment phase",
  },
  extra_stl_text: {
    id: `${scope}.extra_stl_text`,
    defaultMessage:
      "To continue case number {caseNumber} you have to upload extra STL files",
  },
  extra_stl_subtext: {
    id: `${scope}.extra_stl_subtext`,
    defaultMessage:
      "The files already supplied are incomplete or not in order. Unfortunately, the order is now on hold and the expected delivery date can change. As soon as we receive the new / extra STL files, we will start the order and issue a new expected delivery date. ",
  },
  extra_stl_placeholder: {
    id: `${scope}.extra_stl_placeholder`,
    defaultMessage: "Reason for request",
  },
  extra_stl_note: {
    id: `${scope}.extra_stl_note`,
    defaultMessage: "For questions you can always call us.",
  },
  selectAction: {
    id: `${scope}.selectAction`,
    defaultMessage: "Select action",
  },

  emptyMessageLabel: {
    id: `${scope}.emptyMessageLabel`,
    defaultMessage: "Empty Message",
  },
  uploadExtraSTLFilesLabel: {
    id: `${scope}.uploadExtraSTLFilesLabel`,
    defaultMessage: "Upload extra STL-Files",
  },
});
